/* Be Neo — PDP de trafego (sections/beneo-pdp.liquid).
   Saiu de assets/lp02.js quando a LP02 virou advertorial: aqui ficou o que
   pertence ao corpo de venda (galeria, before/after, reels, abas de review e o
   dock), e la ficou o que pertence ao listicle. Ver docs/13-landing-pages.md. */

function pick(i){
  document.querySelectorAll('.slide').forEach(function(s,j){ s.dataset.on = j===i?'1':'0'; });
  document.querySelectorAll('.thumb').forEach(function(t,j){ t.setAttribute('aria-selected', j===i); });
  document.querySelectorAll('.gdot').forEach(function(d,j){ d.setAttribute('aria-selected', j===i); });
}
/* o bloco de oferta virou assets/lp-offer.js, compartilhado com a outra LP */

/* --- */

(function(){
  var rail=document.getElementById('barail');
  if(!rail) return;
  var prev=document.getElementById('baprev'), next=document.getElementById('banext');
  function step(){
    var a=rail.querySelectorAll('.pair');
    return a[1] ? a[1].getBoundingClientRect().left-a[0].getBoundingClientRect().left
                : a[0].getBoundingClientRect().width+22;
  }
  function go(d){
    var max=rail.scrollWidth-rail.clientWidth;
    rail.scrollTo({left:Math.max(0,Math.min(max,rail.scrollLeft+d))});
  }
  function sync(){
    prev.disabled = rail.scrollLeft<4;
    next.disabled = rail.scrollLeft > rail.scrollWidth-rail.clientWidth-4;
  }
  prev.addEventListener('click',function(){go(-step());});
  next.addEventListener('click',function(){go(step());});
  rail.addEventListener('scroll',function(){clearTimeout(rail._t);rail._t=setTimeout(sync,60);});
  window.addEventListener('resize',sync);
  sync();
})();

/* --- */

(function(){
  var rail=document.getElementById('rrail');
  if(!rail) return;
  var cards=rail.querySelectorAll('.vcard');
  var dots=document.getElementById('rdots');
  var prev=document.getElementById('rprev'), next=document.getElementById('rnext');
  var marks=[];

  function step(){
    var a=cards[0].getBoundingClientRect();
    var b=cards[1]?cards[1].getBoundingClientRect():null;
    return b ? b.left-a.left : a.width+16;
  }
  function stops(){
    var max=rail.scrollWidth-rail.clientWidth;
    return max<4 ? 1 : Math.ceil(max/step())+1;
  }
  function buildDots(){
    var n=stops();
    if(marks.length===n) return;
    dots.innerHTML=''; marks=[];
    for(var i=0;i<n;i++){
      var d=document.createElement('i');
      dots.appendChild(d); marks.push(d);
      (function(k){ d.addEventListener('click',function(){ go(k*step()-rail.scrollLeft); }); })(i);
    }
    dots.style.display = n>1 ? 'flex' : 'none';
  }
  function go(delta){
    var max=rail.scrollWidth-rail.clientWidth;
    rail.scrollTo({left:Math.max(0,Math.min(max,rail.scrollLeft+delta))});
  }
  function sync(){
    var idx=Math.round(rail.scrollLeft/step());
    idx=Math.max(0,Math.min(marks.length-1,idx));
    for(var i=0;i<marks.length;i++) marks[i].className = (i===idx?'on':'');
    prev.disabled = rail.scrollLeft<4;
    next.disabled = rail.scrollLeft > rail.scrollWidth-rail.clientWidth-4;
  }
  prev.addEventListener('click',function(){ go(-step()); });
  next.addEventListener('click',function(){ go(step()); });
  rail.addEventListener('scroll',function(){ clearTimeout(rail._t); rail._t=setTimeout(sync,60); });
  window.addEventListener('resize',function(){ buildDots(); sync(); });

  // troca o poster pelo video no primeiro clique. O listener sai depois de trocar:
  // ele fica na <figure>, entao um clique nos controles do proprio video subiria
  // ate aqui e recriaria o elemento — pausar reiniciaria do zero.
  cards.forEach(function(card){
    function abrir(){
      var src=card.getAttribute('data-src');
      if(!src) return;
      card.removeEventListener('click',abrir);
      var poster=card.querySelector('img');
      var v=document.createElement('video');
      v.src=src; v.controls=true; v.autoplay=true; v.playsInline=true; v.preload='auto';
      v.setAttribute('playsinline','');
      if(poster) v.setAttribute('poster',poster.getAttribute('src'));
      card.innerHTML=''; card.appendChild(v);
      var p=v.play();
      if(p && p.catch) p.catch(function(){});
    }
    card.addEventListener('click',abrir);
  });

  buildDots(); sync();
})();

/* --- */

function revTab(btn,id){
  btn.parentNode.querySelectorAll('button').forEach(function(b){ b.setAttribute('aria-selected','false'); });
  btn.setAttribute('aria-selected','true');
  ['rev-product','rev-store'].forEach(function(k){
    document.getElementById(k).hidden = (k !== id);
  });
}

/* --- */

(function(){
  var dock=document.getElementById('dock'), kit=document.getElementById('kit');
  if(!dock||!kit) return;
  // Na LP02 a referencia era `.lhero`: o dock so acendia depois do hero E com a
  // caixa de compra fora da tela. Aqui o #kit E o topo da pagina, entao a regra
  // se resume a uma coisa so — o dock existe para quando a buybox ja passou.
  // Sem esta troca o dock nunca acenderia: `.lhero` nao existe nesta pagina.
  function update(){
    dock.classList.toggle('on', kit.getBoundingClientRect().bottom < 0);
  }
  addEventListener('scroll', update, {passive:true});
  addEventListener('resize', update);
  update();
})();
